// extracted by mini-css-extract-plugin
export default {"main_profile":"MainProfile_main_profile__k26oz"};